import BankLogo from 'components/BankLogo'
import CurrencyLogo from 'components/CurrencyLogo'
import AddCircle from 'components/Icons/AddCircle'
import Arrow, { ArrowSide } from 'components/Icons/Arrow'
import palette from 'components/palette'
import React from 'react'
import styled from 'styled-components'
import { px } from 'utils'

const AddCircleWrapper = styled.div`
  svg {
    margin-top: 4px;
  }
`

const AddLogo = () => (
  <AddCircleWrapper>
    <AddCircle fill={palette.blue400} />
  </AddCircleWrapper>
)

const iconComponentByType = {
  add: AddLogo,
  bank: ({ symbol }) => <BankLogo name={symbol} />,
  currency: ({ symbol }) => <CurrencyLogo currency={symbol} size={px('1.5rem')} />,
  wire: () => <Arrow color={palette.blue400} side={ArrowSide.DOWN} />
}

const RowIcon = ({ symbol, type }) => {
  const Icon = iconComponentByType[type]
  return <Icon symbol={symbol} />
}

export default RowIcon
